import { render, staticRenderFns } from "./protocolDetail.vue?vue&type=template&id=2f4d0b96"
import script from "./protocolDetail.vue?vue&type=script&lang=ts"
export * from "./protocolDetail.vue?vue&type=script&lang=ts"
import style0 from "./protocolDetail.vue?vue&type=style&index=0&id=2f4d0b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports